import { Row, SectionHeader, Title } from '@ydistri/ds';
import React from 'react';
import { EntityListSourceType } from '@ydistri/api-sdk';
import EntityListSourceTypeIcon from '../../../../../components/domain/EntityLists/EntityListSourceTypeIcon';
import ArchivedEntityListIcon from '../../../../../components/domain/EntityLists/ArchivedEntityListIcon';
import DataDeletedEntityListIcon, {
  DataDeletedOf,
} from '../../../../../components/domain/EntityLists/DataDeletedEntityListIcon';

interface EntityListItemsSectionHeaderProps {
  title: string | null | undefined;
  entityListSourceType: EntityListSourceType;
  archived?: boolean;
  /** Whose data were deleted, when they were; the icon replaces the archived one. */
  dataDeleted?: DataDeletedOf;
}

const EntityListItemsSectionHeader: React.FC<EntityListItemsSectionHeaderProps> = ({
  title,
  archived = false,
  dataDeleted,
  entityListSourceType,
}) => {
  return (
    <SectionHeader>
      <Row $gap="1rem" $alignItems="center">
        <EntityListSourceTypeIcon entityListSourceType={entityListSourceType} />
        <Row $gap="0.75rem">
          <Title>{title ?? '-no title-'}</Title>
          {dataDeleted ? (
            <DataDeletedEntityListIcon of={dataDeleted} />
          ) : (
            archived && <ArchivedEntityListIcon />
          )}
        </Row>
      </Row>
    </SectionHeader>
  );
};

export default EntityListItemsSectionHeader;
